import axios from 'axios'
import { Message } from 'element-ui'
import store from '@/store'
import router from '@/router'
import apiConfig from '../../config/config'

const service = axios.create({
  baseURL: apiConfig.apiUrl + '/api',
  timeout: 10000
})

service.interceptors.request.use(
  config => {
    // 先从 vuex 取（正常情况），取不到再从 localStorage 兜底
    const token = store.getters['user/token'] || localStorage.getItem('token')
    if (token) {
      config.headers['Authorization'] = 'Bearer ' + token
    }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

service.interceptors.response.use(
  response => {
    const res = response.data
    if (res.code !== 200) {
      Message.error(res.message || '请求失败')
      if (res.code === 401) {
        store.dispatch('user/logout')
        router.push('/login')
      }
      return Promise.reject(new Error(res.message || '请求失败'))
    }
    return res
  },
  error => {
    Message.error(error.message || '网络错误')
    return Promise.reject(error)
  }
)

export default service
